// dependencies
import { useAutoAnimate } from "@formkit/auto-animate/react";
import React from "react";
import { useParams } from "react-router-dom";

// components
import Spacer from "../../../../../../../components/Spacer";
import Typography from "../../../../../../../components/Text";
import AddMessage from "./components/AddMessage";

//services
import { useGoalHistory, useRbacObjectPermissions } from "../../../../../../../api/hooks";
//hooks
import usePageWidthBreakpoint from "../../../../../../../hooks/usePageWidthBreakpoint";

// utils
import { isEntryMessageOnly } from "../../utils";

// styles
import css from "../../ActivityStreamPanel.module.scss";
import HistoryListEntry from "../HistoryListEntry";
import HistoryMessageEntry from "../HistoryMessageListEntry";

const ActivityStream = () => {
	const { goal_id: goalId } = useParams<{ goal_id: string }>();
	const { isDesktop } = usePageWidthBreakpoint();

	const { data: permissions } = useRbacObjectPermissions("goal", goalId || "");

	const { data: goalHistory = [] } = useGoalHistory({
		goalID: goalId || "",
		sortDirection: "desc",
		sortName: "_id",
	});

	const canUserAddMessages = permissions?.includes("goals:addComment");

	const [animationParent] = useAutoAnimate();
	return (
		<div className={`${css.panelContent} ${isDesktop ? "" : css.mobile}`}>
			<div className={css.header}>
				<Typography weight="regular" size="sub-heading">
					Activity Stream
				</Typography>
			</div>
			<div className={css.addMessage}>
				{canUserAddMessages ? <AddMessage /> : null}
				<Spacer height={1} />
			</div>
			<div className={css.content}>
				<div className={css.historyList} ref={animationParent}>
					{goalHistory?.map((entry) => {
						return (
							<div key={`history-list-entry-${entry?._id}`} className={css.entryWrapper}>
								{isEntryMessageOnly(entry) ? (
									<HistoryMessageEntry entry={entry} />
								) : (
									<HistoryListEntry entry={entry} />
								)}
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default ActivityStream;
